import omit from 'lodash/omit';

import { IFormAddressConfiguration } from '../../../../../modules/formAddress/types/formAddressTypes';
import { stringCapitalizeFirstLetter } from '../../../../../utils/stringFormat';
import { IPersonalDataInfoEdit } from '../types/info-edit';
import { PersonalDataType } from '../types/meta';

export interface IPersonalDataSaveEditRequest {
    address: Omit<IFormAddressConfiguration, 'airId' | 'addressId'>;
    excludeFileIds: string[];
    personalData: {
        [PersonalDataType.birthDate]?: string;
        [PersonalDataType.birthPlace]?: string;
        doc: {
            [PersonalDataType.dateOfIssue]?: string;
            [PersonalDataType.divisionCode]?: string;
            [PersonalDataType.number]?: string;
            [PersonalDataType.providedByOrganization]?: string;
            [PersonalDataType.series]?: string;
            [PersonalDataType.type]: {
                identificationTypeId: string;
            };
            [PersonalDataType.validFor]?: string;
        };
        [PersonalDataType.nationalityInfo]?: {
            addressId: string;
        };
        [PersonalDataType.email]?: string;
        lastName: string;
        midName: string;
        [PersonalDataType.name]: string;
    };
    withoutConfirm: boolean;
}

export const personalDataSaveEditRequestMapping =
    (
        { address, document, personalData }: IPersonalDataInfoEdit,
        excludeFileIds: string[],
        withoutConfirm?: boolean,
    ): IPersonalDataSaveEditRequest => ({
        address: omit(address, ['addressId', 'airId']),
        excludeFileIds,
        personalData: {
            [PersonalDataType.birthDate]: personalData.birthDate,
            [PersonalDataType.birthPlace]: personalData.birthPlace,
            [PersonalDataType.email]: personalData.email,
            lastName: stringCapitalizeFirstLetter(personalData.surname),
            midName: stringCapitalizeFirstLetter(personalData.patronymic),
            [PersonalDataType.name]: stringCapitalizeFirstLetter(personalData.name),
            [PersonalDataType.nationalityInfo]: personalData.nationalityInfo?.id
                ? { addressId: personalData.nationalityInfo.id }
                : undefined,
            doc: {
                [PersonalDataType.dateOfIssue]: document.dateOfIssue,
                [PersonalDataType.divisionCode]: document.divisionCode,
                [PersonalDataType.number]: document.number,
                [PersonalDataType.providedByOrganization]: document.providedByOrganization,
                [PersonalDataType.series]: document.series,
                [PersonalDataType.type]: {
                    identificationTypeId: document.type.value.toString(),
                },
                [PersonalDataType.validFor]: document.validFor,
            },
        },
        withoutConfirm: withoutConfirm || false,
    });
